export default "__VITE_ASSET__$aKSPQXN__"